import React, { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';
import { useSharedState } from '@trello/shared-state';

// eslint-disable-next-line no-restricted-imports
import { overlayState } from 'app/gamma/src/modules/state/ui/overlay';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import { ReduxProvider } from 'app/src/components/ReduxProvider';

export const Overlays = () => {
  let component = null;

  const PlanSelectionOverlayConnected = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "plan-selection-overlay" */ 'app/src/components/FreeTrial'
      ),
    {
      namedImport: 'PlanSelectionOverlayConnected',
      preload: false,
    },
  );
  const AtlassianAccountMigrationStageOverlays = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlassian-account-migration" */ 'app/src/components/AtlassianAccountMigrationStage'
      ),
    {
      namedImport: 'AtlassianAccountMigrationStageOverlays',
      preload: false,
    },
  );

  const [overlay, setOverlayState] = useSharedState(overlayState);

  if (overlay.overlayType === 'plan-selection') {
    component = overlay.context?.orgId && (
      <PlanSelectionOverlayConnected
        orgId={overlay.context?.orgId}
        startFreeTrialOptions={{ redirect: overlay.context?.redirect }}
        // eslint-disable-next-line react/jsx-no-bind
        onClose={() => {
          setOverlayState({
            overlayType: null,
            context: {},
          });
        }}
      />
    );
  }

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        {component}
        <AtlassianAccountMigrationStageOverlays />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};

export const WithReduxProvider = () => {
  return (
    <ReduxProvider>
      <Overlays />
    </ReduxProvider>
  );
};
